export const formatCurrency = (value, options = {}) => {
  if (value === null || value === undefined) return '-';
  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return '-';

  const decimals =
    typeof options.decimals === 'number'
      ? options.decimals
      : Number.isInteger(numericValue)
        ? 0
        : 2;

  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(numericValue);
};

export const formatDate = (value) => {
  if (!value) return '-';
  return new Intl.DateTimeFormat('es-AR', { dateStyle: 'long' }).format(new Date(value));
};